var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.623423,3.376577 C21.0869024,3.84005637 21.1225546,4.56935345 20.7303798,5.07372786 L20.623423,5.19485158 L13.818,12 L20.623423,18.8051484 C21.1255257,19.3072511 21.1255257,20.1213203 20.623423,20.623423 C20.1599436,21.0869024 19.4306466,21.1225546 18.9262721,20.7303798 L18.8051484,20.623423 L12,13.818 L5.19485158,20.623423 C4.69274891,21.1255257 3.87867966,21.1255257 3.376577,20.623423 C2.91309762,20.1599436 2.87744536,19.4306466 3.26962022,18.9262721 L3.376577,18.8051484 L10.182,12 L3.376577,5.19485158 C2.87447433,4.69274891 2.87447433,3.87867966 3.376577,3.376577 C3.84005637,2.91309762 4.56935345,2.87744536 5.07372786,3.26962022 L5.19485158,3.376577 L12,10.182 L18.8051484,3.376577 C19.3072511,2.87447433 20.1213203,2.87447433 20.623423,3.376577 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/close",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.51fa448d09cf8047aee049bf230643da.svg";
export { ForwardRef as ReactComponent };